angular.module('SpidApp')

.filter('deprecated-isoDtToFrench', function () {
    return function (input) {
        if (!input || input.length === 0) {
            return '';
        }

        var split = input.split(/-|T|:/);
        var yyyy = split[0];
        var mm = split[1];
        var dd = split[2];
        var hh = split[3];
        var m2 = split[4];

        return dd + '/' + mm + '/' + yyyy + ' à ' + hh + 'h' + m2;
    }
})